const ipsAll = [];

ipsAll.push({
  ips: ['jinfeng.dzfpxt.com'],
  modeDes: '锦丰-互联网', // ssl+域名
  webhost: 'https://jinfeng.dzfpxt.com',
  hostIp:  'https://jinfeng.dzfpxt.com/web_api',
  imgHostIp: 'https://jinfeng.dzfpxt.com/images',
  loginType: 'password',
  authClientId: '',
  localStorage: 'RoomTicket/tokenJinfeng',
  hostName: '锦丰镇',
});

ipsAll.push({
  ips: ['localhost'],
  modeDes: '锦丰-互联网', // ssl+域名
  webhost: 'http://localhost:3000',
  hostIp:  'https://jinfeng.dzfpxt.com/web_api',
  imgHostIp: 'https://jinfeng.dzfpxt.com/images',
  loginType: 'password',
  authClientId: '',
  localStorage: 'RoomTicket/tokenJinfeng',
  hostName: '锦丰镇',
});


export {
  ipsAll
};
